import get from 'lodash/get';
import { GET } from 'gandi.redux-fetcher';
import { updateProduct } from '../../actions';
import { createAction } from '../../helpers';
import { selectOneProductById } from '../../selectors';
export const fetchClaimsStart = createAction('Fetch Claims [START]');
export const fetchClaimsSuccess = createAction('Fetch Claims [SUCCESS]');
export const fetchClaimsFail = createAction('Fetch Claims [FAIL]');
export const getClaims = productId => (dispatch, getState) => {
  dispatch(fetchClaimsStart());
  const product = selectOneProductById(getState(), {
    productId
  });
  const fqdn = get(product, 'payload.fqdn');
  if (!fqdn) {
    return Promise.resolve();
  }
  return dispatch(GET(`/domain/domains/${fqdn}/claims`, {
    on2XX: response => dispatch(fetchClaimsSuccess({
      productId,
      claims: response.data
    })),
    not2XX: () => dispatch(fetchClaimsFail())
  }));
};
export const checkSmdFileValidityStart = createAction('Fetch SMD File Validity [START]');
export const checkSmdFileValiditySuccess = createAction('Fetch SMD File Validity [SUCCESS]');
export const checkSmdFileValidityFail = createAction('Fetch SMD File Validity [FAIL]');
const readSmdField = (dataFile, fieldName) => {
  const regex = new RegExp(`^${fieldName}:(.*)$`, 'm');
  const match = dataFile.match(regex);
  return match && match.length > 0 ? match[1].trim() : '';
};
const readSmdFile = dataFile => ({
  marks: readSmdField(dataFile, 'Marks'),
  smdID: readSmdField(dataFile, 'SmdId'),
  labels: readSmdField(dataFile, 'U-labels').split(/,\s*/),
  notBefore: readSmdField(dataFile, 'notBefore'),
  notAfter: readSmdField(dataFile, 'notAfter')
});
export const checkSmdFileValidity = (product, file) => dispatch => {
  const result = {
    fqdn: product.fqdn,
    name: file.name,
    errorMsg: '',
    isValid: false
  };
  dispatch(checkSmdFileValidityStart());
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = upload => {
      resolve(upload.target.result);
    };
    reader.onerror = error => {
      dispatch(checkSmdFileValidityFail(result));
      reject(error);
    };
    reader.readAsText(file);
  });
  return promise.then(dataFile => {
    const payload = {
      ...product.payload,
      smd: dataFile,
      smd_id: undefined
    };
    return dispatch(updateProduct({
      productId: product.id,
      payload
    })).then(res => {
      const failed = res.data.status === 'error';
      const smdError = (res.data.errors || []).find(err => err.name === 'smd');
      if (failed && smdError) {
        dispatch(checkSmdFileValidityFail({
          ...result,
          productId: product.id,
          errorMsg: smdError.description
        }));
      } else {
        dispatch(checkSmdFileValiditySuccess({
          ...result,
          productId: product.id,
          isValid: true,
          ...readSmdFile(dataFile)
        }));
      }
    }).catch(() => {
      dispatch(checkSmdFileValidityFail(result));
    });
  });
};